<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Contents</title>
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Contents">
<p class="ctll" id="p0007-01-0"><span><em>Contents</em></span></p>
<p class="cctu" id="p0007-P-1"><span><a href="#/chapter3#p0009-01-0"><em>Introduction: The Jesus Story </em></a></span>
</p>
<p class="cct1" id="p0007-P-2"><span>
<a href="#/chapter4#cccc1" id="cha1">1. Christ Before Time </a>
</span>
</p>
<p class="cct1" id="p0007-P-3"><span>
<a href="#/chapter5#cccc2" id="cha2">2. Christ in Creation: The Macro Version </a>
</span>
</p>
<p class="cct1" id="p0007-P-4"><span>
<span href="#/chapter6#cccc3" id="cha3" title="Link target outside of Sample">3. Christ in Creation: The Micro Version </span>
</span>
</p>
<p class="cct1" id="p0007-P-5"><span>
<span href="#/chapter7#cccc4" id="cha4" title="Link target outside of Sample">4. Jesus’ Birth and Boyhood </span>
</span>
</p>
<p class="cct1" id="p0007-P-6"><span>
<span href="#/chapter8#cccc5" id="cha5" title="Link target outside of Sample">5. Jesus’ Missing Years </span>
</span>
</p>
<p class="cct1" id="p0007-P-7"><span>
<span href="#/chapter9#cccc6" id="cha6" title="Link target outside of Sample">6. Jesus’ Preparation for Ministry </span>
</span>
</p>
<p class="cct1" id="p0007-P-8"><span>
<span href="#/chapter10#cccc7" id="cha7" title="Link target outside of Sample">7. Jesus’ Baptism and Temptation </span>
</span>
</p>
<p class="cct1" id="p0007-P-9"><span>
<span href="#/chapter11#cccc8" id="cha8" title="Link target outside of Sample">8. Jesus Chooses His Disciples </span>
</span>
</p>
<p class="cct1" id="p0007-P-10"><span>
<span href="#/chapter12#cccc9" id="cha9" title="Link target outside of Sample">9. Jesus’ Mission Statement </span>
</span>
</p>
<p class="cct1" id="p0007-P-11"><span>
<span href="#/chapter13#cccc10" id="cha10" title="Link target outside of Sample">10. Jesus: Healer and Miracle-Worker </span>
</span>
</p>
<p class="cct1" id="p0007-P-12"><span>
<span href="#/chapter14#cccc11" id="cha11" title="Link target outside of Sample">11. Jesus: Teacher and Preacher </span>
</span>
</p>
<p class="cct1" id="p0007-P-13"><span>
<span href="#/chapter15#cccc12" id="cha12" title="Link target outside of Sample">12. The Human Jesus </span>
</span>
</p>
<p class="cct1" id="p0007-P-14"><span>
<span href="#/chapter16#cccc13" id="cha13" title="Link target outside of Sample">13. Jesus’ Trial and Crucifixion </span>
</span>
</p>
<p class="cct1" id="p0007-P-15"><span>
<span href="#/chapter17#cccc14" id="cha14" title="Link target outside of Sample">14. The Atonement and the Harrowing of Hell </span>
</span>
</p>
<p class="cct1" id="p0007-P-16"><span>
<span href="#/chapter18#cccc15" id="cha15" title="Link target outside of Sample">15. The Resurrection, Ascension, and Pentecost </span>
</span>
</p>
<p class="cct1" id="p0007-P-17"><span>
<span href="#/chapter19#cccc16" id="cha16" title="Link target outside of Sample">16. The Return of the King<br/>
</span>
</span>
</p>
<p class="cctu" id="p0007-P-18"><span><em>
<span href="#/chapter20#cccc17" id="cha17" title="Link target outside of Sample">Conclusion: The Jesus Spirit</span>
</em>
</span>
</p>
<p class="cctu" id="p0007-P-19"><span><em>
<span href="#/chapter21#cccc18" id="cha18" title="Link target outside of Sample">Appendix: Post-Apostolic Witnesses</span>
</em>
</span>
</p>
<p class="cctu" id="p0007-P-20"><span><em>
<span href="#/chapter22#cccc19" id="cha19" title="Link target outside of Sample">Notes</span>
</em>
</span>
</p>
<p class="cctu" id="p0007-P-21"><span><em>
<span href="#/chapter23#cccc20" id="cha20" title="Link target outside of Sample">About the Authors </span>
</em>
</span>
</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?f1506384